module.exports = __webpack_public_path__ + "static/media/brokenglass.bcc512b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/brokenglass.png
// module id = 386
// module chunks = 0